import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrSalaryComponentEntity } from "@odata/GeneratedEntityTypes";
import { handleCurrentTemporalPropChange } from "@odata/TemporalUtils";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";

interface IProps extends IFormViewProps<IPrSalaryComponentEntity, null> {
}

class SalaryComponentFormView extends FormViewForExtend<IPrSalaryComponentEntity, IProps> {
    static contextType = AppContext;
    static defaultProps = {
        title: "SalaryComponent:FormTitle"
    };

    async onAfterLoad(){
        const { storage } = this.props;
        return super.onAfterLoad();
    }

    handleChange = (e: ISmartFieldChange): void => {
        const { storage } = this.props;
        storage.handleChange(e);
        // change only current value
        handleCurrentTemporalPropChange(e, storage);
        storage.refreshFields(e.triggerAdditionalTasks);
    };
}

export default withPermissionContext(SalaryComponentFormView);